export default {
  getStatusClient: (state) => state.status_client,
  getClientsList: (state) => state.clients,
  getOneClient(state) {
    const { entity, ...rest } = state.client;
    let client_entity = "";
    if (entity === "fizichiskiy") {
      client_entity = "objects.individual";
    } else if (entity === "yuridiskiy") {
      client_entity = "objects.lagal_entity";
    }
    return {
      client_entity,
      entity,
      ...rest,
    };
  },
  getContracts: (state) => state.contracts,
  getComments: (state) => state.comments,
  getUsers: (state) => state.users,
  getSpheresOfActivity: (state) => state.sphere_of_activity,
  getTargets: (state) => state.targets,
  getAttachmentFiles: (state) => state.attachments,
  GET_CLIENT_GROUPS: (state) => state.client_groups,
  GET_CLIENT_PAYMENT_TYPES: (state) => state.client_payment_types,
  GET_CLIENT_INTERESTED: (state) => state.client_interested,
  GET_CLIENT_REQUESTS: (state) => state.client_requests,
  GET_CLIENT_DATA_TO_EDIT(state) {
    const {
      id,
      target,
      title,
      gender,
      client_request,
      client_interested,
      phones,
      emails,
      payment_type,
      sphere_of_activity,
      birth_date,
      description,
      entity,
    } = state.client;
    return {
      id,
      entity,
      title,
      gender,
      client_request,
      client_interested,
      phones,
      emails,
      payment_type,
      sphere_of_activity: sphere_of_activity && sphere_of_activity.id,
      birth_date,
      description,
      target: target?.id,
    };
  },
  GET_ONE_EMPLOYEE(state) {
    return state.single_employee;
  },
  GET_PAYMENT_INTALLMENTS: (state) => state.payment_installments,
  GET_EMPLOYEE: (state) => state.employee,
};
